/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress>): BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress(), model);
        BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress>): BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress.newInstance(<BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
